import Vue from 'vue'
// 按需引入 element-ui 组件，避免与 babel-plugin-component 冲突
// 如果后续有缺少的组件，再在这里补充即可
import {
  Button,
  Select,
  Option,
  OptionGroup,
  Input,
  InputNumber,
  DatePicker,
  TimePicker,
  Switch,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxGroup,
  Upload,
  Dialog,
  Drawer,
  Form,
  FormItem,
  Row,
  Col,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Pagination,
  Tooltip,
  Tag,
  Progress,
  Divider,
  Loading,
  MessageBox,
  Message,
  Notification
} from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Drawer)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Tag)
Vue.use(Progress)
Vue.use(Divider)

// 全局服务
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
